<template>
  <div id="app" v-if="showNav">
    <NavBar :shouldShowDataManagement="shouldShowDataManagement"/>
  </div>
</template>

<script>
import NavBar from './views/NavBar.vue';
import { publicPaths } from './views/config.js';
import { unleash } from './services/featureFlags';

export default {
  components: { NavBar },
  data() {
    return {
      isAuthReady: false,
      shouldShowDataManagement: false,
    };
  },
  mounted() {
    this.setIsAuthReady();
  },
  computed: {
    currentPath() {
      return this.$route?.path;
    },
    isPublicPath() {
      return publicPaths.some(publicPath => this.currentPath.includes(publicPath));
    },
    showNav() {
      return !this.isPublicPath && this.isAuthReady;
    },
  },
  methods: {
    setIsAuthReady() {
      this.isAuthReady = Boolean(this.$auth && !this.$auth.loading);
      if (!this.isAuthReady) this.addAuthLoadingWatcher();
    },
    addAuthLoadingWatcher() {
      this.$auth.$watch('loading', (loading = true) => {
        this.isAuthReady = !loading;
      });
    },
    initFeatureFlags() {
      unleash.setContextField('userId', this.$auth.user?.email);
      unleash.on('update', () => {
        this.shouldShowDataManagement = unleash.isEnabled('release-data-management-view');
      });
      unleash.init();
    },
  },
  watch: {
    isAuthReady(isReady) {
      if (isReady) this.initFeatureFlags();
    },
  },
};
</script>
